module.exports = __webpack_public_path__ + "media/country_flags/tt-ae14e6e1.png";